var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOutgoingGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#D4BC87;stroke-linecap:round;}\n\t.st1{fill:none;stroke:#D4BC87;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,18.4l2.6-2.6c0.3-0.3,0.9-0.4,1.3-0.1l3.6,2.5c0.5,0.4,0.6,1.1,0.1,1.5l-0.4,0.4c-0.7,0.7-1.7,1-2.7,0.7 c-2.1-0.7-5.8-2.2-8.9-5.3c-3.1-3.1-4.7-6.9-5.3-8.9c-0.3-1,0-2,0.7-2.7L4,3.5c0.4-0.4,1.2-0.4,1.5,0.1L8,7.2 c0.3,0.4,0.2,0.9-0.1,1.3L5.4,11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,4l-5,5 M20,4h-4 M20,4v4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutgoingGold);
export default __webpack_public_path__ + "static/media/phone-outgoing-gold.000cf8fa66d9c7e9119b17f36b4f6dc2.svg";
export { ForwardRef as ReactComponent };